export default __webpack_public_path__ + "static/media/LogoAMG_v3-1.0a59dc03.png";